import { Navigate } from "react-router-dom";

export default function AdminProtected({ children }) {
  const isAdminAuthenticated = !!sessionStorage.getItem("admin");

  if (!isAdminAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
